import React from "react";
import { Button } from "../components/Button";
import { usePlayer } from "@empirica/core/player/classic/react";

export function Choice() {
  const player = usePlayer();

  function onClick(choice) {
    player.round.set("decision", choice);
    // console.log("You chose:", choice);
    player.stage.set("submit", true);
  }

  return (
    <div className="mt-3 sm:mt-5 p-20">
      {/* Alert bar */}
      <div className="flex items-center gap-3 bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
        <span className="text-2xl">🚨</span>
        <p className="text-base font-medium text-red-800">
          You and your partner in crime have been arrested!
        </p>
      </div>
      <div className="rounded-xl mb-6">
        You now must decide what to do. Do you stay silent and hope your partner
        does the same, or do you testify against your partner to cut your
        sentence? The choice is yours, but keep in mind that your partner is
        facing the same decision. What you choose will determine how much time
        you and your partner will spend in jail.
      </div>
      {/* Outcomes table */}
      <div className="border border-gray-200 rounded-xl overflow-hidden mb-6">
        <div className="grid grid-cols-3 bg-gray-50 px-4 py-2 gap-2">
          <span className="text-sm font-medium text-gray-400 uppercase tracking-wide">
            If You...
          </span>
          <span className="text-sm font-medium text-gray-400 uppercase tracking-wide">
            and Your partner...
          </span>
          <span className="text-sm font-medium text-gray-400 uppercase tracking-wide">
            Your sentence will be:
          </span>
        </div>
        {[
          {
            you: "🤐 Stay silent",
            them: "🤐 Stays silent",
            sentence: "2 months",
            style: "bg-teal-50 text-teal-800",
          },
          {
            you: "📣 Testify",
            them: "🤐 Stays silent",
            sentence: "1 month",
            style: "bg-green-50 text-green-800",
          },
          {
            you: "🤐 Stay silent",
            them: "📣 Testifies",
            sentence: "12 months",
            style: "bg-red-50 text-red-800",
          },
          {
            you: "📣 Testify",
            them: "📣 Testifies",
            sentence: "6 months",
            style: "bg-amber-50 text-amber-800",
          },
        ].map((row, i) => (
          <div
            key={i}
            className="grid grid-cols-3 px-4 py-3 gap-2 border-t border-gray-100 items-center"
          >
            <span className="text-sm text-gray-700">{row.you}</span>
            <span className="text-sm text-gray-700">{row.them}</span>
            <span
              className={`text-xs font-medium px-3 py-1 rounded-full w-fit ${row.style}`}
            >
              {row.sentence}
            </span>
          </div>
        ))}
      </div>
      {/* Choice buttons */}
      <p className="text-base font-medium text-gray-900 mb-4">
        What do you do?
      </p>
      <div className="grid grid-cols-2 gap-3">
        <Button
          className="m-5 border border-gray-200 rounded-xl p-5 text-left hover:bg-gray-50 transition-colors"
          handleClick={() => onClick("silent")}
        >
          <div className="text-2xl mb-2">🤐</div>
          <div className="text-sm font-medium text-gray-900 mb-1">
            Stay silent
          </div>
          <div className="text-xs text-gray-500">
            Keep quiet and hope your partner does the same.
          </div>
        </Button>
        <Button
          className="m-5 border border-gray-200 rounded-xl p-5 text-left hover:bg-gray-50 transition-colors"
          handleClick={() => onClick("testify")}
        >
          <div className="text-2xl mb-2">📣</div>
          <div className="text-sm font-medium text-gray-900 mb-1">Testify</div>
          <div className="text-xs text-gray-500">
            Testify against your partner to cut your sentence.
          </div>
        </Button>
      </div>
    </div>
  );
}
